import { Select as AntdSelect, SelectProps } from 'antd';

import { Picker } from '@app/web-components';

import { useSuppliersQuery } from './query';

export const Select = ({ value, ...props }: SelectProps) => {
  const { search, getSelectProps } = Picker.usePicker({
    defaultSearch:
      value && !Array.isArray(value) && props.labelInValue !== false ? value.label?.split('|')?.[1] ?? '' : '',
  });

  const { data, isFetching, isPending } = useSuppliersQuery({
    count: 50,
    name: search.trim() ?? undefined,
  });

  const supplier = data?.find((x) => x.id === Number(value?.value));

  return (
    <AntdSelect
      {...getSelectProps({
        ...props,
        loading: isFetching || isPending,
      })}
      options={data?.map((x) => ({
        value: x.id.toString(),
        label: `${x.id} | ${x.name} | ${x.CountrySubdivisionName}, ${x.CountryName}`,
      }))}
      value={
        props.labelInValue !== false
          ? {
              label: supplier
                ? `${supplier.id} | ${supplier.name} | ${supplier.CountrySubdivisionName}, ${supplier.CountryName}`
                : value?.label,
              value: value?.value,
            }
          : value
      }
    />
  );
};
